import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';
import { CheckProdutoImport, Evento, EventoProdutoImport } from '../models/evento';
import * as XLSX from 'xlsx';
import { ProdutoService } from '../../produto/produto.service';
import { FornecedorService } from '../../fornecedor/fornecedor.service';

type AOA = any[][];
@Component({
  selector: 'app-evento-produto-importar',
  templateUrl: './evento-produto-importar.component.html',
  styleUrls: ['./evento-produto-importar.component.scss']
})
export class EventoProdutoImportarComponent implements OnInit {
//dados: any;
  
  propostasFile: any;
  data: any;
  listaProduto: EventoProdutoImport[] = [];
  novaListaProduto: EventoProdutoImport[] = [];
  checkProduto: CheckProdutoImport[] = [];
  produto: EventoProdutoImport;
  novoProduto: EventoProdutoImport;
  public podeImportar: boolean = false;
  public gridLoading: boolean = false;

  produtoFile: any[];
  displayDialog: boolean;
  propostaEditar: any = {};

  public idEvento: any;
  public eventoDescricao: string;

  mensagensErroValidacao = {
    'produtoNulo': 'O campo produto não pode ser nulo',    
    'fornecedorNulo': 'O campo fornecedor não pode ser nulo e',    
    'qtdeZero': 'O campo quantidade de estoque deve ser maior que ZERO',
    'vlEventoZero': 'O campo valor deve ser maior que ZERO',
    'vlCustoZero': 'O campo custo deve ser maior que ZERO',
    'vlSimNao': 'O campo frete / chapa/ unificado deve ter o valor de "SIM" ou "NAO"',
  };
  mostrarColunaDeErros: boolean = false;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private notificationsService: NotificationsService,
              private produtoService: ProdutoService,
              private fornecedorService: FornecedorService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      if (params.has('idEvento')) {
        this.idEvento = params.get('idEvento');
      }
      if (params.has('descricao')) {
        this.eventoDescricao = params.get('descricao');
      }
    });
  }

  editProduto(produto: EventoProdutoImport) {
    this.produto = produto;
    this.novoProduto = { ...produto };
    this.displayDialog = true;
  }

  // cloneProduto(produto: EventoProdutoImport) {    
  //   for (let prop in produto) {
  //     this.novoProduto[prop] = produto[prop];    }
  //   return this.novoProduto;
  // }

  saveProduto() {
    //console.log(this.produto)
    this.novaListaProduto = [...this.listaProduto];
    this.novaListaProduto[this.listaProduto.indexOf(this.produto)] = this.novoProduto;
    this.listaProduto = this.novaListaProduto;
    this.getCheckProdutoFornecedor();
    this.propostaEditar = null;
    this.displayDialog = false;
  }

  deleteProduto(produto: EventoProdutoImport) {
    console.log(produto);
    console.log(this.listaProduto.indexOf(produto));
    this.listaProduto.splice(this.listaProduto.indexOf(produto),1);    
    this.displayDialog = false;
  }




  hideDialog() {
    this.displayDialog = false;
  }

  validarProdutoFornecedor()
  {
    this.gridLoading = true;
    this.getCheckProdutoFornecedor();
    this.gridLoading = false;
  }

  validarProdutos() {
    let mensagem = [];   

    this.listaProduto.forEach(element => {
      if (!this.validaProduto(element.produto) && !mensagem.includes(this.mensagensErroValidacao.produtoNulo)) {
        mensagem.push(this.mensagensErroValidacao.produtoNulo);
      }
      if (!this.validaFornecedor(element.fornecedor) && !mensagem.includes(this.mensagensErroValidacao.fornecedorNulo)) {
        mensagem.push(this.mensagensErroValidacao.fornecedorNulo);
      }
      if (!this.validaValor(element.qtdeEstoque) && !mensagem.includes(this.mensagensErroValidacao.qtdeZero)) {
        mensagem.push(this.mensagensErroValidacao.qtdeZero);
      }
      if (!this.validaValor(element.vlCusto) && !mensagem.includes(this.mensagensErroValidacao.vlCustoZero)) {
        mensagem.push(this.mensagensErroValidacao.vlCustoZero);
      }
      if (!this.validaValor(element.vlEvento) && !mensagem.includes(this.mensagensErroValidacao.vlEventoZero)) {
        mensagem.push(this.mensagensErroValidacao.vlEventoZero);
      }
    });

     if (mensagem.length > 0) {
       this.podeImportar = false;
       this.notificationsService.toastNotify('error', 'Erro', mensagem.toString());
       this.mostrarColunaDeErros = true;
     }
     else{
      this.notificationsService.toastNotify('success', 'Validação', 'Produtos validados com sucesso.');
       this.podeImportar = true;
     }


  }

  importarProdutos() {
    
    this.produtoService
    .checkImportarProdutoNectar(this.idEvento, this.listaProduto)
    .subscribe(
      () => {           
      //  this.notificationsService.toastNotify('success', 'Sucesso', 'Produtos importados com sucesso!');
        this.listaProduto = null;    
      },
      err => {
        console.log(err);        
      }
    );
  }   

  onFileChange(evt: any) {
    //console.log(evt.target);
    this.listaProduto = [];
    this.mostrarColunaDeErros = false;

    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      
      this.data.forEach(element => {

        if ((element[0] != "Produto") && (element[0] != null)) {

          var reg = { produto: element[0], fornecedor: element[1], vlEvento: element[2], vlCusto: element[3], peso: element[4], qtdeEstoque: element[5], flFrete: element[6], flChapa: element[7], flUnificado: element[8],existeProduto: false, existeFornecedor: false };
          if (reg != null) {                        
            //console.log(reg);
            //this.checkProduto = this.checkProduto.concat({produto: element[0], fornecedor: element[1], existeProduto: true, existeFornecedor: true});
            //this.checkProduto = this.checkProduto.concat(reg);
            //console.log(this.checkProduto);
            this.listaProduto.push(reg);         
          }
        }
      });
    };
    console.log(this.listaProduto);
    reader.readAsBinaryString(target.files[0]);         
  }

  validaProduto(produto) {    
    if (produto){
      if (this.existeProduto(produto))
        return true;
      else{
        this.mensagensErroValidacao.produtoNulo = "O campo produto deve estar cadastrado no Nectar";
        return false;
      }

    }
    else {      
      return false;
    }
  }

  validaFornecedor(fornecedor) {
    if (fornecedor) {
      if (this.existeFornecedor(fornecedor))
        return true;
      else{
        this.mensagensErroValidacao.fornecedorNulo = "O campo fornecedor deve estar cadastrado no SIGEVE";
        return false;
      }
    }
    else {
      return false;
    }
  }

  validaValor(valor) {
    if (valor && valor > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  validaSimNao(valor) {
    if (valor && (valor.toUpperCase() == "SIM" || valor.toUpperCase()  == "NAO")) {
      return true;
    }
    else {
      return false;
    }
  }

  baixarArquivo() {
    let link = document.createElement("a");
    link.download = "ModeloImportarProduto.xlsx";
    link.href = "./assets/template-importacao/ModeloImportarProduto.xlsx";
    link.click();
  }

  backClick() {
    this.router.navigate(['/evento-list'])

  }

  logClick() {
    this.router.navigate(['/evento-produto-importar-log'])

  }

  existeProduto(produto: string)
  {
    let existe = this.listaProduto.find(x => x.produto === produto);
    return existe.existeProduto;
  }

  existeFornecedor(fornecedor: string)
  {
    let existe = this.listaProduto.find(x => x.fornecedor === fornecedor);
    return existe.existeFornecedor;
  }

  getCheckProdutoFornecedor()
  {
    this.produtoService
    .checkProdutoNectar(this.listaProduto)
    .subscribe(
      (response) => {           
        this.listaProduto = response;
        console.log(this.listaProduto);
        this.validarProdutos()        
      },
      err => {
        console.log(err);        
      }
    );
  }


}
